export default {
      id: "ic_fast_deposit_transactions_empty-usage",
      viewBox: "0 0 164 161",
      url: "/" + "images/icons.3.109.2.svg#ic_fast_deposit_transactions_empty-usage",
      toString: function () {
        return this.url;
      }
    }